/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `classification` - classification
 * * `regression` - regression
 * @export
 */
export const ModelTypeEnum = {
  classification: 'classification',
  regression: 'regression',
} as const;
export type ModelTypeEnum = (typeof ModelTypeEnum)[keyof typeof ModelTypeEnum];

export function instanceOfModelTypeEnum(value: any): boolean {
  for (const key in ModelTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(ModelTypeEnum, key)) {
      if ((ModelTypeEnum as Record<string, ModelTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ModelTypeEnumFromJSON(json: any): ModelTypeEnum {
  return ModelTypeEnumFromJSONTyped(json, false);
}

export function ModelTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelTypeEnum {
  return json as ModelTypeEnum;
}

export function ModelTypeEnumToJSON(value?: ModelTypeEnum | null): any {
  return value as any;
}
